import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        QuizGarden &copy; {new Date().getFullYear()} - a focused trivia sprint built with React.
      </div>
    </footer>
  );
}
